if (!customElements.get("shipping-bar")) {
  customElements.define(
    "shipping-bar",
    class ShippingBar extends HTMLElement {
      constructor() {
        super();
        this.init();
      }

      init() {
        this.amount_els = this.querySelectorAll(".value");
        this.cartDraw =
          this.closest("cart-drawer") ||
          this.closest(".ca__free-shipping") ||
          this.closest(".main-cart");

        this.inner_bar = this.querySelector(".sb__bar .inner");
        if (!this.cartDraw) return; //attached to cartDraw as rest gets rebuilt

        this.setSize();

        //check collisons with tier to check off or cross out
        this.tiers = this.querySelectorAll(".bar-tier");
        if (this.tiers[0] && this.inner_bar) {
          //TODO make more efficient
          requestAnimationFrame(this.collisionCheck.bind(this));
        }
      }

      collisionCheck() {
        for (let i = 0; i < Array.from(this.tiers).length; i++) {
          const tier_el = this.tiers[i];

          const over_limit =
            this.inner_bar.getBoundingClientRect().right >
            tier_el.getBoundingClientRect().right;

          tier_el.dataset.over = over_limit;

          this.handleTierCopy(tier_el.dataset.index, over_limit);
        }

        requestAnimationFrame(this.collisionCheck.bind(this));
      }

      handleTierCopy(index, isOver) {
        var matching_copy_el = this.querySelector(
          `.tier-copy[data-index="${index}"]`,
        );

        if (!matching_copy_el) return;

        matching_copy_el.dataset.over = isOver;
      }

      setSize() {
        var limit = parseInt(this.dataset.limit);
        var total = this.dataset.potentialItems
          ? parseInt(this.dataset.cartTotal) +
            parseInt(this.dataset.potentialItems)
          : parseInt(this.dataset.cartTotal);

        var distance = (total / limit) * 100;

        var current_location =
          document.querySelector("main")?.dataset.location ?? "en";
        var current_currency =
          document.querySelector("main")?.dataset.currency ?? "AUD";

        //new shipping bar uses server side logic to handle value, capp stil needs client side
        Array.from(this.amount_els).forEach((amount_el) => {
          let money = new Intl.NumberFormat(current_location, {
            style: "currency",
            currency: current_currency,
            currencyDisplay: "narrowSymbol",
          });
          //amount_el.innerHTML = Shopify.formatMoney(limit - total);
          amount_el.innerHTML = money.format((limit - total) / 100);
        });

        //set size property on cart draw as the rest gets replaced
        setTimeout(() => {
          //timeout to ensure element has be rendered
          this.cartDraw.style.setProperty(
            "--shipping-distance",
            `${distance > 100 ? 100 : distance}%`,
          );
          this.cartDraw.dataset.distance = distance > 100 ? 100 : distance;
        }, 0);
      }
    },
  );
}
